module.exports = __webpack_public_path__ + "assets/img/success@2x.ed543ba4.png";